module.exports = __webpack_public_path__ + "static/media/wecan_mobile.6d2ec90f.svg";